import { FaRegTrashAlt } from "react-icons/fa";
import React, { useState } from "react";

import { PaziaButton } from "components/atoms";

import { AddTermsModalProps } from "components/templates/AddTermsModal/AddTermsModal";
import { HiOutlinePencil } from "react-icons/hi";
import { CourseTermsApi } from "api/courseTermsApi";
import { CourseTermsFormValues } from "components/templates/AddTermsModal/CreateTermsForm";
import { UpdateTermsFormValues } from "components/templates/AddTermsModal/UpdateTermsForm";
import { MdOpenInNew } from "react-icons/md";

interface PaziaTermsListProps {
  terms: CourseTermsApi[];
  onTermDelete: (termId: number) => Promise<void>;
  onCreateSubmit: (values: CourseTermsFormValues) => Promise<void>;
  onUpdateSubmit: (values: UpdateTermsFormValues) => Promise<void>;
}
export const PaziaTermsList = ({
  terms,
  onTermDelete,
  onCreateSubmit,
  onUpdateSubmit,
}: PaziaTermsListProps): JSX.Element | null => {
  const [termModal, setTermModal] = useState<CourseTermsApi | null>(null);

  return (
    <>
      <div className="flex flex-col divide-y-2">
        {/* TODO Pokaz jakie regulami sa dodane przez kategorie */}
        {terms.length === 0 && <div className="text-center text-sm text-slate-500">Brak dodanych regulaminów.</div>}
        {terms.map((term) => (
          <div key={term.id} className="flex items-center justify-between py-2">
            <div className="">
              <div className="inline-flex font-semibold text-slate-800 dark:text-slate-100">{term.name}</div>

              <div className="text-sm">{term.description}</div>
            </div>
            <div className="flex items-center gap-2">
              <FaRegTrashAlt
                title="Usuń"
                size={20}
                onClick={() => onTermDelete(term.id)}
                className="cursor-pointer hover:text-slate-600"
              />
              <HiOutlinePencil
                title="Edytuj"
                size={20}
                className="cursor-pointer hover:text-slate-600"
                onClick={() => setTermModal(term)}
              />
              <a target="_blank" href={term.link}>
                <MdOpenInNew className="cursor-pointer hover:text-slate-600" size={20} />
              </a>
            </div>
          </div>
        ))}
      </div>
      <div className="flex justify-end gap-2 border-t-2 pt-2">
        <PaziaButton title="Dodaj regulamin" type="primary" onClick={() => setTermModal({} as CourseTermsApi)} />
      </div>
      <AddTermsModalProps
        onUpdateSubmit={async (v) => {
          await onUpdateSubmit(v);
          setTermModal(null);
        }}
        onCreateSubmit={async (v) => {
          await onCreateSubmit(v);
          setTermModal(null);
        }}
        terms={termModal}
        onCloseRequest={() => setTermModal(null)}
      />
    </>
  );
};
